module.exports = __webpack_public_path__ + "static/media/cosmic-canopy.f01e7428.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/cosmic-canopy.jpg
// module id = 112
// module chunks = 0